import config from '../config/config'

export const isDesktop = (global) => global && global.innerWidth >= config.breakpoints.lg

export const isMobile = (global) => global && global.innerWidth < config.breakpoints.md
